import setLayoutAndViewportData from './setLayoutAndViewportData.js';

export default function setMPRLayout(
  displaySet,
  viewportPropsArray,
  numRows = 2,
  numColumns = 2
) {
  return new Promise((resolve, reject) => {
    const viewports = [];
    const numViewports = numRows * numColumns;
    //('viewportPropsArray', viewportPropsArray);
    //('viewportPropsArray.length', viewportPropsArray.length);
    //('numViewports', numViewports);

    const viewportSpecificData = {};

    for (let i = 0; i < numViewports; i++) {
      viewports.push({});
      // Clone instead of mutating `displaySet` in place — it's the same
      // object referenced by the current Redux state (state.viewports.
      // viewportSpecificData[activeViewportIndex]) when called via the
      // toolbar/commandsManager, and mutating it outside a reducer can
      // desync things that rely on it (e.g. which thumbnail is highlighted).
      viewportSpecificData[i] = Object.assign({}, displaySet, {
        plugin: 'vtk',
      });
    }

    const apis = [];
    viewports.forEach((viewport, index) => {
      apis[index] = null;
      const viewportProps = viewportPropsArray[index];
      viewports[index] = Object.assign({}, viewports[index], {
        vtk: {
          mode: 'mpr', // TODO: not used
          afterCreation: api => {
            apis[index] = api;

            if (apis.every(a => !!a)) {
              resolve(apis);
            }
          },
          ...viewportProps,
        },
      });
    });

    setLayoutAndViewportData(
      {
        numRows,
        numColumns,
        viewports,
      },
      viewportSpecificData
    );
  });
}
